import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
} from 'lexical';
import { useEffect } from 'react';

import { INSERT_SLOT_COMMAND } from '../commands';
import { $createSlotNode } from '../SlotNode';

export const InsertSlotPlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_SLOT_COMMAND,
      ({ slotName }: { slotName: string }) => {
        editor.update(() => {
          const selection = $getSelection();
          if ($isRangeSelection(selection)) {
            if (!selection.isCollapsed()) {
              selection.removeText();
            }
            const slotNode = $createSlotNode(slotName);
            selection.insertNodes([slotNode]);
          }
        });
        return true;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor]);

  return null;
};
